import React from 'react';

import ENUMS from '../../../enums/index';
import generateClassName from '../../../utils/generateClassName';

import ShowForPermission from '../../../components/ShowForPermission';
import TableRow from './TableRow';

function ReserveRequestsListTable(props) {
  const { reservationRequestsList = [], pageNumber, pageSize, sortType, sortedColumn } = props;

  return (
    <table className="table table-striped table-bordered">
      <thead>
        <tr>
          <th className="text-center">{locales('tables.row')}</th>
          <th onClick={() => props.sortTable('createdFullName')} className="text-center pointer">
            <i
              name="createdFullName"
              className={generateClassName('createdFullName', sortedColumn, sortType)}
            />
            {locales('tables.requestor')}
          </th>
          <th onClick={() => props.sortTable('date')} className="text-center pointer">
            <i name="date" className={generateClassName('date', sortedColumn, sortType)} />
            {locales('fields.createdAt')}
          </th>
          <th onClick={() => props.sortTable('startAt')} className="text-center pointer">
            <i name="startAt" className={generateClassName('startAt', sortedColumn, sortType)} />
            {locales('tables.reserveStartingTime')}
          </th>
          <th onClick={() => props.sortTable('endAt')} className="text-center pointer">
            <i name="endAt" className={generateClassName('endAt', sortedColumn, sortType)} />
            {locales('tables.reserveEndingTime')}
          </th>
          <th className="text-center">{locales('messages.tables')}</th>
          <th onClick={() => props.sortTable('reserveType')} className="text-center pointer">
            <i
              name="reserveType"
              className={generateClassName('reserveType', sortedColumn, sortType)}
            />
            {locales('tables.reservationType')}
          </th>
          <th onClick={() => props.sortTable('trackingNumber')} className="text-center pointer">
            <i
              name="trackingNumber"
              className={generateClassName('trackingNumber', sortedColumn, sortType)}
            />
            {locales('fields.trackingNumber')}
          </th>
          <th onClick={() => props.sortTable('persons')} className="text-center pointer">
            <i name="persons" className={generateClassName('persons', sortedColumn, sortType)} />
            {locales('tables.peopleCount')}
          </th>
          <th onClick={() => props.sortTable('meal')} className="text-center pointer">
            <i name="meal" className={generateClassName('meal', sortedColumn, sortType)} />
            {locales('tables.mealPortions')}
          </th>
          <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_REQUESTS_RESERVES_FOR_ADMIN}>
            <th className="text-center">{locales('fields.cafe.name')}</th>
          </ShowForPermission>
          <th className="text-center"></th>
        </tr>
      </thead>
      <tbody>
        {reservationRequestsList.length > 0 ? (
          reservationRequestsList.map((reserve, index) => (
            <TableRow
              ix={index}
              id={reserve.id}
              key={reserve.id}
              pageNumber={pageNumber}
              pageSize={pageSize}
              createdFullName={reserve.createdFullName}
              isSuspended={reserve.isSuspended}
              createdAt={reserve.createdAt}
              startAt={reserve.startAt}
              endAt={reserve.endAt}
              reservedTables={reserve.reservedTables}
              reserveType={reserve.reserveType}
              trackingNumber={reserve.trackingNumber}
              persons={reserve.persons}
              meal={reserve.meal}
              cafeName={reserve.cafeName}

              displayReserveDetailsModal={props.displayReserveDetailsModal}
            />
          ))
        ) : (
          <tr className="col-12 text-center">
            <td className="alert alert-info" colSpan={13}>
              {locales('alerts.noRecord')}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default ReserveRequestsListTable;
